import { z } from 'zod';

const isValidCPF = (cpf: string) => {
  let sum = 0;

  const clearedCPF = cpf.replace(/\./g, '').replace('-', '');
  const invalidCPFs = ['01234567890', '12345678901'];

  for (let i = 0; i < 10; i++) invalidCPFs.push(i.toString().repeat(11));

  if (clearedCPF.length !== 11 || invalidCPFs.indexOf(clearedCPF) > -1) return false;

  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(clearedCPF.substring(i - 1, i)) * (11 - i);
  }

  let rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(clearedCPF.substring(9, 10))) return false;

  sum = 0;

  for (let i = 1; i <= 10; i++) {
    sum = sum + parseInt(clearedCPF.substring(i - 1, i)) * (12 - i);
  }

  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(clearedCPF.substring(10, 11))) return false;

  return true;
};

type CpfValidatorOptionsType = {
  messages?: Partial<{
    required: string;
    invalid: string;
  }>;
};

const cpfValidator =
  ({ messages }: CpfValidatorOptionsType = {}) =>
  (cpf: string, ctx: z.RefinementCtx) => {
    if (!cpf) {
      ctx.addIssue({
        code: 'custom',
        message: messages?.required || 'O CPF é obrigatório',
      });
      return;
    }

    if (!isValidCPF(cpf)) {
      ctx.addIssue({
        code: 'custom',
        message: messages?.invalid || 'O CPF está inválido',
      });
    }
  };

export default cpfValidator;
